// Generated by ReScript, PLEASE EDIT WITH CARE

import * as App from "./App.res.js";
import * as Providers from "./core/Providers.res.js";
import * as AppVersion from "./core/AppVersion.res.js";
import * as BugTracker from "./core/BugTracker.res.js";
import * as LegacyDashboard from "./modules/LegacyDashboard.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function Root(props) {
  if (LegacyDashboard.redirect()) {
    return null;
  } else {
    return JsxRuntime.jsx(Providers.make, {
      children: JsxRuntime.jsxs(BugTracker.Boundary.make, {
        children: [
          JsxRuntime.jsx(App.make, {}),
          JsxRuntime.jsx(AppVersion.Checker.make, {})
        ]
      })
    });
  }
}

let make = Root;

export {
  make,
}
/* App Not a pure module */
